// Hide (§2.8 rule 8): the card disappears and never comes back.

import styles from './HideButton.module.css'

export default function HideButton({ onHide, busy }: { onHide: () => void; busy?: boolean }) {
  return (
    <button
      type="button"
      className={styles.hideBtn}
      onClick={onHide}
      disabled={busy}
      aria-label="Скрыть карточку"
    >
      Скрыть
    </button>
  )
}
